import equals from 'ramda/src/equals'
import myProfileSelector from 'root/src/client/logic/route/selectors/myProfileSelector'
import {
	VIEW_CREATOR_DATA_ROUTE_ID, VIEW_FACEBOOK_CREATOR_DATA_ROUTE_ID,
	VIEW_TIKTOK_CREATOR_DATA_ROUTE_ID,
	VIEW_YT_CREATOR_DATA_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'

export default (state) => {
	const { routeId } = myProfileSelector(state)
	return equals(routeId, VIEW_CREATOR_DATA_ROUTE_ID)
        || equals(routeId, VIEW_YT_CREATOR_DATA_ROUTE_ID)
        || equals(routeId, VIEW_TIKTOK_CREATOR_DATA_ROUTE_ID)
        || equals(routeId, VIEW_FACEBOOK_CREATOR_DATA_ROUTE_ID)
}
